import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {baseUrl} from '../PatUniv.js'
const PatDrugDetails = (props) => {
    const pat_id = localStorage.getItem('pat_id');
    const [rows, setRows] = useState([]);
    const [rows1, setRows1] = useState([]);
    const [patientData, setPatientData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response1 = await axios.get(`${baseUrl}pat-search-view/${pat_id}/`);
                if (response1.status === 200 || response1.status === 201) {
                    setPatientData(response1.data);
                    const patId = response1.data[0].id;
                    const response2 = await axios.get(`${baseUrl}pat-op-consult/${patId}/`);
                    const opData = response2.data.map((data) => ({...data, type: 'op'}));
                    const response6 = await axios.get(`${baseUrl}pat-ip-consult/${patId}/`);
                    const ipData = response6.data.map((data) => ({
                        id: data.id,
                        ip__ip_id: data.ip.ip_id,
                        pat__pat_id: data.pat.pat_id,
                        pat__patient: data.pat.patient,
                        drug_id: data.drug_id,
                        drug_status: data.drug_status,
                        qty: data.qty,
                    }));
                    setRows1(ipData);
                    const combined = [...opData];
                    setRows(combined);
                } else {
                    window.location.href = '/pat-menu/';
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [pat_id]);
    useEffect(() => {
        const ids = [
            ...new Set(
                [...rows, ...rows1]
                    .map(row => row.drug_id)
                    .filter(Boolean)
                    .flatMap(id =>
                        String(id)
                            .split(',')
                            .map(item => item.trim())
                    )
            )
        ];
        if (ids.length > 0) {
            axios.post(baseUrl + 'pat-bulk-indent-use-bill/', {
                ids: ids,
            })
                .then(res => {
                    console.log("Requested IDs:", ids);
                    console.log("Returned Data:", res.data);
                    setViewPharmData(res.data);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }, [rows, rows1]);
    const columns = [
        {field: 'add_date', headerName: 'Appt Date', width: 120},
        {
            field: 'appt_id',
            headerName: 'Appt ID',
            width: 200,
            renderCell: (params) => (
                params.row.appt?.appt_id || ''
            ),
        },
        {
            field: 'drug_id',
            headerName: 'Medicine',
            width: 350,
            renderCell: (params) => {
                const drugIds = params.row.drug_id
                    ? String(params.row.drug_id).split(',').map(item => item.trim())
                    : [];
                const qtys = params.row.dose
                    ? String(params.row.dose).split(',').map(item => item.trim())
                    : [];
                return (
                    <div style={{lineHeight: '1.5', paddingTop: '8px'}}>
                        {drugIds.map((id, index) => {
                            const medicine = viewPharmData.find(
                                item => String(item.id) === String(id)
                            );
                            return (
                                <div key={index}>
                                    {medicine?.product_name || 'Unknown Medicine'}
                                    {qtys[index] ? ` - Qty: ${qtys[index]}` : ''}
                                </div>
                            );
                        })}
                    </div>
                );
            },
        },
        {field: 'freq', headerName: 'Frequency', width: 200},
        {field: 'dose', headerName: 'Qty', width: 100},
        {field: 'remarks', headerName: 'Remarks', width: 100},
        {field: 'addedby', headerName: 'Added by', width: 100},
        {
            field: 'prescription',
            headerName: 'Prescription',
            width: 100,
            renderCell: (params) => (
                <Link
                    to={`/pat-drug-pres/${pat_id}/${params.row.appt.id}/`}
                    className="btn btn-success"
                >
                    View
                </Link>
            ),
        },
    ];
    const columns1 = [
        {
            field: 'ip__ip_id',
            headerName: 'IP ID',
            width: 100,
            renderCell: (params) => (
                <Link to={`/ip-pat-view/${params.row.id}/`}>
                    {params.row.ip__ip_id}
                </Link>
            ),
        },
        {
            field: 'pat__pat_id',
            headerName: 'Pat Id',
            width: 80,
        },
        {
            field: 'pat__patient',
            headerName: 'Patient',
            width: 150,
        },
        {
            field: 'drug_id',
            headerName: 'Medicine',
            width: 350,
            renderCell: (params) => {
                const drugIds = params.row.drug_id
                    ? String(params.row.drug_id).split(',').map(item => item.trim())
                    : [];
                return (
                    <div style={{lineHeight: '1.5', paddingTop: '8px'}}>
                        {drugIds.map((id, index) => {
                            const medicine = viewPharmData.find(
                                item => String(item.id) === String(id)
                            );
                            return (
                                <div key={index}>
                                    {medicine?.product?.product || 'Unknown Medicine'}
                                </div>
                            );
                        })}
                    </div>
                );
            },
        },
        {
            field: 'qty',
            headerName: 'Qty',
            width: 100,
        },
        {
            field: 'prescription',
            headerName: 'Prescription',
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <Link
                    to={`/pat-discharge-summary/${params.row.id}/`}
                    className="btn btn-warning"
                >
                    View
                </Link>
            ),
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row table-responsive">
                <div className="col-md-12 col-12 mb-2">
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>Patient ID</th>
                            <th>Patient Name</th>
                            <th>Gender</th>
                            <th>D.O.B/Age</th>
                            <th>Mobile</th>
                            <th>Regd. On</th>
                        </tr>
                        </thead>
                        <tbody>
                        {patientData.map((patientData, index) => (
                            <tr key={index}>
                                <td>{patientData.pat_id}</td>
                                <td>{patientData.patient}</td>
                                <td>{patientData.gender}</td>
                                <td>{patientData.age}</td>
                                <td>{patientData.mobile}</td>
                                <td>{patientData.add_date}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{height: '100%', width: '100%'}}>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true" style={{color: 'red'}}></i> OP Drug Prescription</h3>
                <DataGrid
                    className="mt-4"
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    slots={{toolbar: GridToolbar}}
                    autoHeight
                />
            </div>
            <div style={{height: '100%', width: '100%'}} className="mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true" style={{color: 'red'}}></i> IP Drug Prescription</h3>
                <DataGrid
                    className="mt-4"
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    rows={rows1}
                    columns={columns1}
                    pageSize={10}
                    slots={{toolbar: GridToolbar}}
                    autoHeight
                />
            </div>
        </section>
    );
};
export default PatDrugDetails;
